// TS equivalents of Catalyst's ApiUtils.handleAPIRequest + ErrorUtils.resolveError.

// Belt.Result runtime shape from the repos: Ok = { TAG: 0, _0 }, Error = { TAG: 1, _0 }.
interface RepoResult {
  TAG: number;
  _0: unknown;
}

export function handleAPIRequest<T = unknown>(
  apiRequest: () => Promise<RepoResult>,
  onSuccess: (data: T) => void,
  onError: (error: unknown) => void,
): void {
  void apiRequest().then((result): void => {
    if (result.TAG === 0) {
      onSuccess(result._0 as T);
    } else {
      onError(result._0);
    }
  });
}

// Catalyst error entity: DefaultError({ title, message }) => { _0: { message } }.
export function resolveError(error: unknown): string {
  return (error as { _0: { message: string } })._0.message;
}
